const serviceCentersData = {
  jerusalem: {
    googleLink:
      "https://www.google.com/maps/place/%D7%94%D7%92%D7%9F+%D7%94%D7%98%D7%9B%D7%A0%D7%95%D7%9C%D7%95%D7%92%D7%99,+Derech+Agudat+Sport+HaPo'el+2,+Jerusalem%E2%80%AD/@31.7498445,35.1838231,17z/data=!3m1!4b1!4m5!3m4!1s0x1502d78eb5f7372b:0xb45807afb551e1e5!8m2!3d31.7498445!4d35.1860118",
    wazeLink:
      "https://www.waze.com/live-map/directions/il/%D7%9E%D7%97%D7%95%D7%96-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%94%D7%92%D7%9F-%D7%94%D7%98%D7%9B%D7%A0%D7%95%D7%9C%D7%95%D7%92%D7%99?to=place.ChIJKzf3tY7XAhUR5eFRta8HWLQ",
  },

  telAviv: {
    googleLink:
      "https://www.google.com/maps/place/Yad+Harutsim+St+12,+Tel+Aviv-Yafo/@32.0616901,34.7806267,17z/data=!3m1!4b1!4m5!3m4!1s0x151d4b7add800443:0x386365eb7ed8897f!8m2!3d32.0616901!4d34.7828154",
    wazeLink:
      "https://www.waze.com/live-map/directions/%D7%AA%D7%9C-%D7%90%D7%91%D7%99%D7%91-%D7%99%D7%A4%D7%95?to=place.ws.il.7054.12",
  },

  haifa: {
    googleLink:
      "https://www.google.com/maps/place/Sderot+HaPalyam+2,+Haifa,+3309503/@32.8167795,34.9979205,17z/data=!3m1!4b1!4m5!3m4!1s0x151dbb216f06b6b3:0x3cf43aa702518ba1!8m2!3d32.8167795!4d35.0001092",
    wazeLink:
      "https://www.waze.com/live-map/directions/il/haifa-district/haifa/sderot-hapalyam-2?to=place.ChIJs7YGbyG7HRURoYtRAqc69Dw",
  },

  lod: {
    googleLink:
      "https://www.google.com/maps/dir//%D7%A0%D7%9E%D7%9C+%D7%AA%D7%A2%D7%95%D7%A4%D7%94+%D7%91%D7%9F+%D7%92%D7%95%D7%A8%D7%99%D7%95%D7%9F+-+70100%E2%80%AD%E2%80%AD%E2%80%AD/@32.0031355,34.8472358,13z",
    wazeLink:
      "https://www.waze.com/live-map/directions/%D7%A0%D7%9E%D7%9C-%D7%AA%D7%A2%D7%95%D7%A4%D7%94-%D7%91%D7%9F-%D7%92%D7%95%D7%A8%D7%99%D7%95%D7%9F-%E2%9C%88-%D7%A0%D7%9E%D7%9C-%D7%AA%D7%A2%D7%95%D7%A4%D7%94-%D7%91%D7%9F-%D7%92%D7%95%D7%A8%D7%99%D7%95%D7%9F?to=place.w.22872384.228723839.508592",
  },
};

export const getGoogleMapsLink = (cityLabel: string) => {
  switch (cityLabel) {
    case "תל אביב":
      return serviceCentersData["telAviv"]["googleLink"];
    case "ירושלים":
      return serviceCentersData["jerusalem"]["googleLink"];
    case "חיפה":
      return serviceCentersData["haifa"]["googleLink"];
    case "לוד":
      return serviceCentersData["lod"]["googleLink"];
    default:
      return "";
  }
};

export const getWazeLink = (cityLabel: string) => {
  switch (cityLabel) {
    case "תל אביב":
      return serviceCentersData["telAviv"]["wazeLink"];
    case "ירושלים":
      return serviceCentersData["jerusalem"]["wazeLink"];
    case "חיפה":
      return serviceCentersData["haifa"]["wazeLink"];
    case "לוד":
      return serviceCentersData["lod"]["wazeLink"];
    default:
      return "";
  }
};
